import config from './config'
import HubReferenceInput from './input'

const HubsFilter = (props) => <HubReferenceInput {...props} validate={null} />

HubsFilter.defaultProps = { source: config.options.referenceKey }

export default HubsFilter
